/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const PaperPlane = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="16" fill="#1B6FD8" />
      <path d="M24 8L8 15.5L13.5 17L16.5 23L18.5 18L24 8Z" fill="white" />
      <path d="M13.5 17L16.5 23" stroke="white" strokeWidth="0.8" fill="none" />
    </BaseSvgIcon>
  )
}

export default PaperPlane
